<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Liquor Certificate Dashboard</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row">
            <div class="col-12">
              <div class="page-header-box mb-4">
                <h4 class="page-header-title">LIQUOR CERTIFICATE QUICK STATS</h4>
                <p class="page-header-description">Overview of alcoholic drinks licensing activities and revenue performance</p>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <ToolBarLiquor/>

          <!-- Count Statistics Cards -->
          <div class="row">
            <div class="col-xl-2 col-md-4 col-sm-6 mb-4">
              <div class="card stats-card-mini h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stats-icon-mini bg-gradient-info">
                      <i class="bx bx-buildings"></i>
                    </div>
                    <div class="ms-3">
                      <p class="text-muted mb-1 small text-truncate">Potential Businesses</p>
                      <h4 class="mb-0 fw-bold">{{ numberFormat(liquorCertQuickStats.liquorLicenceCountSummary.potentialBusinesses) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4 col-sm-6 mb-4">
              <div class="card stats-card-mini h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stats-icon-mini bg-gradient-primary">
                      <i class="bx bx-receipt"></i>
                    </div>
                    <div class="ms-3">
                      <p class="text-muted mb-1 small text-truncate">Invoiced Businesses</p>
                      <h4 class="mb-0 fw-bold">{{ numberFormat(liquorCertQuickStats.liquorLicenceCountSummary.invoicedBusinesses) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4 col-sm-6 mb-4">
              <div class="card stats-card-mini h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stats-icon-mini bg-gradient-danger">
                      <i class="bx bx-time-five"></i>
                    </div>
                    <div class="ms-3">
                      <p class="text-muted mb-1 small text-truncate">Unpaid Invoices</p>
                      <h4 class="mb-0 fw-bold text-danger">{{ numberFormat(liquorCertQuickStats.liquorLicenceCountSummary.unPaidInvoices) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4 col-sm-6 mb-4">
              <div class="card stats-card-mini h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stats-icon-mini bg-gradient-success">
                      <i class="bx bx-check-circle"></i>
                    </div>
                    <div class="ms-3">
                      <p class="text-muted mb-1 small text-truncate">Paid Invoices</p>
                      <h4 class="mb-0 fw-bold text-success">{{ numberFormat(liquorCertQuickStats.liquorLicenceCountSummary.paidInvoices) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4 col-sm-6 mb-4">
              <div class="card stats-card-mini h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stats-icon-mini bg-gradient-warning">
                      <i class="bx bx-loader-circle"></i>
                    </div>
                    <div class="ms-3">
                      <p class="text-muted mb-1 small text-truncate">Awaiting Approval</p>
                      <h4 class="mb-0 fw-bold text-warning">{{ numberFormat(liquorCertQuickStats.liquorLicenceCountSummary.awaitingApproval) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4 col-sm-6 mb-4">
              <div class="card stats-card-mini h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stats-icon-mini bg-gradient-teal">
                      <i class="bx bx-badge-check"></i>
                    </div>
                    <div class="ms-3">
                      <p class="text-muted mb-1 small text-truncate">Active Certificates</p>
                      <h4 class="mb-0 fw-bold">{{ numberFormat(liquorCertQuickStats.liquorLicenceCountSummary.activeCertificates) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Revenue Statistics Cards -->
          <div class="row">
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card revenue-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-start justify-content-between">
                    <div>
                      <p class="text-muted mb-2 fw-medium">Value of Pending Invoices</p>
                      <h4 class="mb-0 fw-bold">KES {{ numberFormat(liquorCertQuickStats.liquorLicenceAmountSummary.pendingInvoicesSum) }}</h4>
                    </div>
                    <div class="revenue-icon bg-danger-subtle">
                      <i class="mdi mdi-account-cash text-danger"></i>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-transparent border-top py-3">
                  <span class="badge bg-soft-danger text-danger">
                    <i class="bx bx-trending-down me-1"></i>Outstanding Balance
                  </span>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card revenue-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-start justify-content-between">
                    <div>
                      <p class="text-muted mb-2 fw-medium">Today's Collections</p>
                      <h4 class="mb-0 fw-bold">KES {{ numberFormat(liquorCertQuickStats.liquorLicenceAmountSummary.todaysCollectionsSum) }}</h4>
                    </div>
                    <div class="revenue-icon bg-info-subtle">
                      <i class="mdi mdi-calendar-text-outline text-info"></i>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-transparent border-top py-3">
                  <span class="badge bg-soft-info text-info">
                    <i class="bx bx-calendar-check me-1"></i>{{ todayDate }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card revenue-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-start justify-content-between">
                    <div>
                      <p class="text-muted mb-2 fw-medium">This Month's Collections</p>
                      <h4 class="mb-0 fw-bold">KES {{ numberFormat(liquorCertQuickStats.liquorLicenceAmountSummary.thisMonthsCollectionsSum) }}</h4>
                    </div>
                    <div class="revenue-icon bg-primary-subtle">
                      <i class="mdi mdi-calendar-month-outline text-primary"></i>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-transparent border-top py-3">
                  <span class="badge bg-soft-primary text-primary">
                    <i class="bx bx-calendar me-1"></i>{{ currentMonth }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card revenue-card highlight-card h-100 mb-0">
                <div class="card-body">
                  <div class="d-flex align-items-start justify-content-between">
                    <div>
                      <p class="text-white-50 mb-2 fw-medium">This FY Collections</p>
                      <h4 class="mb-0 fw-bold text-white">KES {{ numberFormat(liquorCertQuickStats.liquorLicenceAmountSummary.financialYearCollectionsSum) }}</h4>
                    </div>
                    <div class="revenue-icon bg-white-subtle">
                      <i class="mdi mdi-calendar-check-outline text-white"></i>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-transparent border-top border-light py-3">
                  <span class="badge bg-white-subtle text-white">
                    <i class="bx bx-trending-up me-1"></i>FY {{ currentFY }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content Row -->
          <div class="row">
            <!-- Sub County Statistics Table -->
            <div class="col-xl-6 mb-4">
              <div class="card h-100 mb-0">
                <div class="card-header bg-white border-bottom">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <div class="table-header-icon me-2">
                        <i class="bx bx-bar-chart-alt-2"></i>
                      </div>
                      <h4 class="card-title mb-0">Important Statistics</h4>
                    </div>
                    <button @click="downloadStatistics()" class="btn btn-sm btn-soft-primary">
                      <i class="bx bx-download me-1"></i>Export
                    </button>
                  </div>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
                    <table class="table table-hover align-middle mb-0 table-striped">
                      <thead class="table-dark sticky-top">
                      <tr>
                        <th class="ps-3">Sub County</th>
                        <th class="text-center">Invoiced Vs Potential</th>
                        <th>Pending Invoices</th>
                        <th>Paid SBPs</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in liquorCertQuickStats.statistics" :key="index" class="table-row-hover" style="cursor: pointer;">
                        <td class="ps-3">
                          <div class="d-flex align-items-center">
                            <div class="location-badge me-2">
                              {{ getInitials(item.subCountyName) }}
                            </div>
                            <span class="fw-medium">{{ item.subCountyName }}</span>
                          </div>
                        </td>
                        <td class="text-center">-</td>
                        <td class="table-danger">
                          <span class="fw-semibold">{{ numberFormat(item.pendingCount) }}</span>
                          <span class="text-dark ms-1">(Sh {{ numberFormat(item.pendingTotal) }})</span>
                        </td>
                        <td class="table-success">
                          <span class="fw-semibold">{{ numberFormat(item.paidCount) }}</span>
                          <span class="text-dark ms-1">(Sh {{ numberFormat(item.paidTotalSum) }})</span>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th class="ps-3"><strong>Total</strong></th>
                        <th class="text-center">-</th>
                        <td class="text-danger">
                          <span class="fw-bold">{{ numberFormat(totalPendingCount) }}</span>
                          <span class="fw-bold ms-1">(Sh {{ numberFormat(totalPendingTotal) }})</span>
                        </td>
                        <td class="text-success">
                          <span class="fw-bold">{{ numberFormat(totalPaidCount) }}</span>
                          <span class="fw-bold ms-1">(Sh {{ numberFormat(totalPaidTotalSum) }})</span>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Revenue Performance Chart -->
            <div class="col-xl-6 mb-4">
              <div class="card h-100 mb-0">
                <div class="card-header bg-white border-bottom">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <div class="table-header-icon chart-icon me-2">
                        <i class="bx bx-line-chart"></i>
                      </div>
                      <h4 class="card-title mb-0">Revenue Performance</h4>
                    </div>
                    <div class="d-flex align-items-center gap-3">
                      <div class="legend-item">
                        <span class="legend-dot bg-secondary"></span>
                        <span class="small text-muted">Last Year</span>
                      </div>
                      <div class="legend-item">
                        <span class="legend-dot bg-success"></span>
                        <span class="small text-muted">This Year</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div id="revenuePerfomanceFire" style="height: 350px;"></div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">County Billing System</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import Highcharts from 'highcharts';
import 'highcharts/modules/drilldown';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/accessibility';
import 'highcharts/modules/gantt';

Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
    decimalPoint: '.'
  }
});

import NavigationBar from "@/components/Navigation.vue";
import ToolBarLiquor from "@/components/liquor/ToolBarLiquor.vue";
import { liquor, execute, biller } from "@/api";
import moment from "moment";

export default {
  name: "CertAlcoholDashboard",
  components: { ToolBarLiquor, NavigationBar },

  data() {
    return {
      paymentMode: '',
      loading: false,
      liquorCertQuickStats: {
        liquorLicenceCountSummary: {
          potentialBusinesses: null,
          invoicedBusinesses: null,
          paidInvoices: null,
          unPaidInvoices: null,
          awaitingApproval: null,
          activeCertificates: null,
        },
        liquorLicenceAmountSummary: {
          pendingInvoicesSum: null,
          todaysCollectionsSum: null,
          thisMonthsCollectionsSum: null,
          financialYearCollectionsSum: null,
        },
        revenuePerformance: [
          ["Jan", 0, 0],
          ["Feb", 0, 0],
          ["Mar", 0, 0],
          ["Apr", 0, 0],
          ["May", 0, 0],
          ["Jun", 0, 0],
          ["Jul", 0, 0],
          ["Aug", 0, 0],
          ["Sep", 0, 0],
          ["Oct", 0, 0],
          ["Nov", 0, 0],
          ["Dec", 0, 0]
        ],
        statistics: []
      },
      totalPendingCount: 0,
      totalPendingTotal: 0,
      totalPaidCount: 0,
      totalPaidTotalSum: 0,
    }
  },

  computed: {
    todayDate() {
      return moment().format('DD MMM YYYY');
    },
    currentMonth() {
      return moment().format('MMMM YYYY');
    },
    currentFY() {
      const now = moment();
      const fiscalYearStart = now.month() >= 6 ? now.year() : now.year() - 1;
      return `${fiscalYearStart}/${fiscalYearStart + 1}`;
    }
  },

  mounted() {
    this.getDashboard();
    this.menuAccess();
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Cert Alcohol Dashboard");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch(() => {});
    },

    numberFormat(num) {
      if (!num) return '0';
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },

    getInitials(name) {
      if (!name) return '??';
      const words = name.trim().split(' ');
      if (words.length >= 2) {
        return (words[0][0] + words[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },

    revenuePerformance() {
      function abbreviateMonth(month) {
        return month.substring(0, 3);
      }

      var data = this.liquorCertQuickStats.revenuePerformance;

      Highcharts.setOptions({
        chart: {
          style: {
            fontFamily: 'Inter, Montserrat, sans-serif'
          }
        }
      });

      Highcharts.chart('revenuePerfomanceFire', {
        chart: {
          type: 'column',
          backgroundColor: 'transparent'
        },
        title: {
          text: null
        },
        xAxis: {
          categories: data.map(item => abbreviateMonth(item[0])),
          labels: {
            style: {
              color: '#64748b',
              fontSize: '11px'
            }
          },
          lineColor: '#e2e8f0',
          tickColor: '#e2e8f0'
        },
        yAxis: {
          title: {
            text: 'Revenue (KES)',
            style: {
              color: '#64748b',
              fontSize: '11px'
            }
          },
          labels: {
            style: {
              color: '#64748b',
              fontSize: '11px'
            },
            formatter: function() {
              return Highcharts.numberFormat(this.value, 0);
            }
          },
          gridLineColor: '#f1f5f9'
        },
        legend: {
          enabled: true
        },
        tooltip: {
          shared: true,
          backgroundColor: '#1e293b',
          borderColor: '#1e293b',
          borderRadius: 8,
          style: {
            color: '#fff'
          },
          pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>KES {point.y:,.0f}</b><br/>'
        },
        plotOptions: {
          column: {
            borderRadius: 4,
            pointPadding: 0.1,
            groupPadding: 0.15
          }
        },
        series: [{
          name: 'Last Year Collections',
          data: data.map(item => item[1]),
          color: '#94a3b8'
        }, {
          name: 'This Year Collections',
          data: data.map(item => item[2]),
          color: '#10b981'
        }],
        credits: {
          enabled: false
        }
      });
    },

    getDashboard() {
      const data = new FormData();
      data.append("function", "getDashboard");
      execute(data, liquor)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.liquorCertQuickStats = res.data.data.liquorCertQuickStats;

              this.totalPendingCount = this.liquorCertQuickStats.statistics.reduce((acc, cur) => {
                let amountToday = Number(cur.pendingCount);
                if (!isNaN(amountToday)) {
                  return acc + amountToday;
                } else {
                  return acc;
                }
              }, 0);

              this.totalPendingTotal = this.liquorCertQuickStats.statistics.reduce((acc, cur) => {
                let amountToday = Number(cur.pendingTotal);
                if (!isNaN(amountToday)) {
                  return acc + amountToday;
                } else {
                  return acc;
                }
              }, 0);

              this.totalPaidCount = this.liquorCertQuickStats.statistics.reduce((acc, cur) => {
                let amountToday = Number(cur.paidCount);
                if (!isNaN(amountToday)) {
                  return acc + amountToday;
                } else {
                  return acc;
                }
              }, 0);

              this.totalPaidTotalSum = this.liquorCertQuickStats.statistics.reduce((acc, cur) => {
                let amountToday = Number(cur.paidTotalSum);
                if (!isNaN(amountToday)) {
                  return acc + amountToday;
                } else {
                  return acc;
                }
              }, 0);

              this.revenuePerformance();
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    downloadStatistics() {
      try {
        const headers = ['Sub County', 'Invoiced Vs Potential', 'Pending Count', 'Pending Amount', 'Paid Count', 'Paid Amount'];
        const csvRows = [headers.join(',')];

        this.liquorCertQuickStats.statistics.forEach((item) => {
          const row = [
            `"${item.subCountyName || ''}"`,
            '-',
            item.pendingCount || 0,
            item.pendingTotal || 0,
            item.paidCount || 0,
            item.paidTotalSum || 0
          ];
          csvRows.push(row.join(','));
        });

        csvRows.push('');
        csvRows.push(`"TOTAL","-",${this.totalPendingCount},${this.totalPendingTotal},${this.totalPaidCount},${this.totalPaidTotalSum}`);

        const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `liquor_statistics_${moment().format('YYYY-MM-DD')}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error('Error generating CSV:', error);
      }
    }
  }
}
</script>

<style scoped>
/* Page Header */
.page-header-box {
  background: #f8f9fa;
  padding: 20px 24px;
  border-radius: 0;
  border-bottom: 3px solid #1a2b4a;
}

.page-header-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a2b4a;
  margin-bottom: 4px;
  letter-spacing: 0.5px;
}

.page-header-description {
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 0;
}

/* Statistics Cards Mini */
.stats-card-mini {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  transition: transform 0.2s, box-shadow 0.2s;
}

.stats-card-mini:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.stats-icon-mini {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: white;
  flex-shrink: 0;
}

.bg-gradient-info {
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
}

.bg-gradient-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.bg-gradient-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.bg-gradient-warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.bg-gradient-teal {
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
}

/* Revenue Cards */
.revenue-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}

.revenue-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.12);
}

.revenue-card.highlight-card {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
}

.revenue-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.bg-danger-subtle {
  background: rgba(239, 68, 68, 0.1);
}

.bg-info-subtle {
  background: rgba(6, 182, 212, 0.1);
}

.bg-primary-subtle {
  background: rgba(99, 102, 241, 0.1);
}

.bg-white-subtle {
  background: rgba(255, 255, 255, 0.2);
}

.bg-soft-danger {
  background: rgba(239, 68, 68, 0.1) !important;
}

.bg-soft-info {
  background: rgba(6, 182, 212, 0.1) !important;
}

.bg-soft-primary {
  background: rgba(99, 102, 241, 0.1) !important;
}

.bg-soft-success {
  background: rgba(16, 185, 129, 0.1) !important;
}

/* Table Styles */
.table-header-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
}

.table-header-icon.chart-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.location-badge {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: #4f46e5;
  flex-shrink: 0;
}

.table-row-hover:hover {
  background-color: #f8fafc !important;
}

/* Legend */
.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

/* Buttons */
.btn-soft-primary {
  background-color: rgba(99, 102, 241, 0.1);
  color: #6366f1;
  border: none;
}

.btn-soft-primary:hover {
  background-color: #6366f1;
  color: white;
}

/* Scrollbar */
.table-responsive::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

/* Sticky header */
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>